// extracted by mini-css-extract-plugin
export var confirmationBtns = "ConfirmationPopUp-module--confirmationBtns--63138";
export var container = "ConfirmationPopUp-module--container--d75f9";
export var heading = "ConfirmationPopUp-module--heading--9cd5f";
export var mainContainer = "ConfirmationPopUp-module--mainContainer--cb065";
export var message = "ConfirmationPopUp-module--message--b3850";